import { AuthGuardProvider } from "common/auth/guard/provider";
import { FrontendVersion } from "components/frontend-version";
import { Layout } from "components/layout";
import { RiskyEmailSurveyHandler } from "components/risky-email-survey-handler";
import { SignupCompleteHandler } from "components/signup-complete-handler";
import Upscope from "components/upscope";
import WwwSearchHandler from "components/www-search-handler";
import Cookies from "js-cookie";
import Router from "routes/router";
import ScrollTopPageChange from "routes/scroll-top-page-change";

const App = () => {
  Cookies.set("amf_app_visited", "1", {
    domain: process.env.REACT_APP_COOKIE_DOMAIN,
    expires: 365,
  });

  return (
    <AuthGuardProvider>
      <Layout>
        <Router />
      </Layout>

      <FrontendVersion />
      <ScrollTopPageChange />
      <SignupCompleteHandler />
      <RiskyEmailSurveyHandler />
      <Upscope />
      <WwwSearchHandler />
    </AuthGuardProvider>
  );
};

export default App;
